export const getPhoneNumberWithCountryCode = (
  countryCode: string,
  phoneNumber: string,
) => {
  // Remove the first zero if it exists
  const formattedPhoneNumber = phoneNumber.startsWith("0")
    ? phoneNumber.slice(1)
    : phoneNumber;

  return `+${countryCode} ${formattedPhoneNumber}`;
};
